export default __webpack_public_path__ + "img/244ba8e8b330b71bdf5ccc326f8b4924.svg";